import { create } from "zustand";
import { ISessions } from "./ISessions";
import { addMonths, endOfMonth, startOfMonth, subMonths } from "date-fns";

export const sessions_store_initial_state = {
  sessionsData: undefined,
  previousSessionThresholdReached: false,
  nextSessionThresholdReached: false,
  startDate: startOfMonth(subMonths(new Date(), 1)),
  endDate: endOfMonth(addMonths(new Date(), 1)),
  loadingInitial: true,
  loadingNext: false,
  loadingPrevious: false,
  showHappeningSoon: undefined,
};

export const useSessionsStore = create<ISessions.ISessionStore>((set) => ({
  ...sessions_store_initial_state,
  setSessionsData: (value) => set({ sessionsData: value }),

  setEndDate: (value) => set({ endDate: value }),

  setStartDate: (value) => set({ startDate: value }),

  setNextSessionThresholdReached: (value) =>
    set({ nextSessionThresholdReached: value }),

  setPreviousSessionThresholdReached: (value) =>
    set({ previousSessionThresholdReached: value }),

  setShowHappeningSoon: (value) => set({ showHappeningSoon: value }),

  setLoadingInitial: (value) => set({ loadingInitial: value }),
  setLoadingNext: (value) => set({ loadingNext: value }),
  setLoadingPrevious: (value) => set({ loadingPrevious: value }),

  reset: () => set(sessions_store_initial_state),
}));
